// extracted by mini-css-extract-plugin
export default {"root":"FormGridTemplate_root__g6SOM","placeHolderShimmer":"FormGridTemplate_placeHolderShimmer__AngH7"};